export default __webpack_public_path__ + "static/truck_w.047aae55d953ff3291b8a38fc0b7c643.svg";